export const appName = process.env.REACT_APP_NAME;

export const apiUrl = process.env.REACT_APP_API_URL;
export const appUrl = process.env.REACT_APP_URL;

export const captcha_client_site_key = '6LfSZbMaAAAAAAXrDmDdj79pz6Tkx_8qqLzX6Og8';
